import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UserDetailsState {
  username: string | null;
  email: string | null;
  role: string | null;
  referralCode: string | null;
  primaryAirlineCode: string | null;
  setUsername: (name: string | null) => void;
  setEmail: (email: string | null) => void;
  setUserRole: (role: string | null) => void;
  setReferralCode: (code: string | null) => void;
  setPrimaryAirlineCode: (code: string | null) => void;
}

export const useUserStore = create(
  persist<UserDetailsState>(
    (set) => ({
      username: "Username",
      email: null,
      role: null,
       referralCode: null,
      primaryAirlineCode: null,
      setUsername: (name: string | null) => set({ username: name }),
      setEmail: (email: string | null) => set({ email: email }),
      setUserRole: (role: string | null) => set({ role: role }),
      setReferralCode: (code: string | null) => set({ referralCode: code }),
      setPrimaryAirlineCode: (code: string | null) => set({ primaryAirlineCode: code }),
    }),
    {
      name: "userDetails",
    }
  )
);
